import { Skeleton } from '@/components/ui'
import { ClienteCardSkeleton } from '@/shared/cliente-card'
import { generateArrayIds } from '@/utils/array.utils'

export const BuscaClienteSkeleton = () => {
  return (
    <div className="space-y-4 p-4" data-testid="busca-cliente-skeleton">
      <div className="br-12 mx-auto w-full space-y-8 sm:max-w-4xl">
        <Skeleton className="h-6 w-60" />
        <div className="bg-foreground border-muted space-y-8 rounded-sm rounded-b-none border-b-1 p-6 shadow-xs">
          <Skeleton className="mb-6 h-6 w-64" />
          <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
            <div className="flex flex-col gap-2">
              <Skeleton className="h-5 w-32" />
              <Skeleton className="h-10 w-full rounded-md" />
            </div>
            <div className="flex flex-col gap-2">
              <Skeleton className="h-5 w-48" />
              <Skeleton className="h-10 w-full rounded-md" />
            </div>
            <div className="flex flex-col gap-2">
              <Skeleton className="h-5 w-24" />
              <Skeleton className="h-10 w-full rounded-md" />
            </div>
          </div>
          <div className="mt-10 flex justify-end gap-4">
            <Skeleton className="h-10 w-36 rounded-md" />
            <Skeleton className="h-10 w-36 rounded-md" />
          </div>
        </div>
        <div className="tiny-scrollbar mx-auto mt-1 max-h-234 w-full space-y-4 overflow-auto overflow-x-hidden rounded-sm rounded-b-none bg-white p-4 shadow-xs sm:max-w-4xl">
          {generateArrayIds(5).map((id) => (
            <ClienteCardSkeleton key={id} />
          ))}
        </div>
        <div className="mx-auto flex w-full flex-col gap-4 sm:max-w-4xl">
          <div className="border-muted mx-auto -mt-2 flex w-full justify-end space-y-4 rounded-sm rounded-t-none border-t-1 bg-white p-4 shadow-xs">
            <Skeleton className="h-12 w-40 rounded-md" />
          </div>
          <div className="flex justify-end gap-6">
            <Skeleton className="h-7 w-24" />
            <span className="flex gap-2">
              <Skeleton className="h-7 w-7 rounded-md" />
              <Skeleton className="h-7 w-7 rounded-md" />
              <Skeleton className="h-7 w-7 rounded-md" />
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
